import ProfileSetup from "./ProfileSetup";
import UpdateProfileSetup from "./UpdateProfileSetup";
export {ProfileSetup, UpdateProfileSetup};
